/**
 * Stable form IDs for agreement/legal forms. Used by app and tests.
 */
export const FORM_IDS = {
  PRIVACY_POLICY: "genomic-life-privacy-policy",
  TERMS_AND_CONDITIONS: "genomic-life-terms-and-conditions",
  HIPAA_AUTHORIZATION: "genomic-life-hipaa-authorization"
} as const;
